// extracted by mini-css-extract-plugin
export var columnWrap = "diversity-module--column-wrap--61tsH";
export var description = "diversity-module--description--ssYTo";
export var diversity = "diversity-module--diversity--dSDBZ";